export const NAICS_CODES = {
  options: [
    {
      label: 'Accommodation (721)',
      value: '721',
    },
    {
      label: 'Accounting, Tax Preparation, Bookkeeping, and Payroll Services (5412)',
      value: '5412',
    },
    {
      label: 'Activities Related to Credit Intermediation (5223)',
      value: '5223',
    },
    {
      label: 'Activities Related to Real Estate (5313)',
      value: '5313',
    },
    {
      label: 'Administration and Support Services (561)',
      value: '561',
    },
    {
      label: 'Administration of Economic Programs (926) ',
      value: '926',
    },
    {
      label: 'Administration of Environmental Quality Programs (924)',
      value: '924',
    },
    {
      label: 'Administration of Housing Programs, Urban Planning, and Community Development (925)',
      value: '925',
    },
    {
      label: 'Administration of Human Resource Programs (923)',
      value: '923',
    },
    {
      label: 'Advertising, Public Relations, and Related Services (5418)',
      value: '5418',
    },
    {
      label: 'Agencies, Brokerages, and Other Insurance Related Activities (5242)',
      value: '5242',
    },
    {
      label: 'Air Transportation (481)',
      value: '481',
    },
    {
      label: 'Amusement Parks and Arcades',
      value: '7131',
    },
    {
      label: 'Animal Production (112)',
      value: '112',
    },
    {
      label: 'Apparel Manufacturing (315)',
      value: '315',
    },
    {
      label: 'Apparel, Piece Goods, and Notions Merchant Wholesalers (4243)',
      value: '4243',
    },
    {
      label: 'Architectural, Engineering, and Related Services (5413)',
      value: '5413',
    },
    {
      label: 'Automobile Dealers (4411)',
      value: '4411',
    },
    {
      label: 'Automotive Equipment Rental and Leasing (5321)',
      value: '5321',
    },
    {
      label: 'Automotive Parts, Accessories and Tire Stores (4413)',
      value: '4413',
    },
    {
      label: 'Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers (4248)',
      value: '4248',
    },
    {
      label: 'Beverage and Tobacco Product Manufacturing (312)',
      value: '312',
    },
    {
      label: 'Broadcasting (except Internet)(515)',
      value: '515',
    },
    {
      label: 'Building Material Garden Equipment and Supplies Dealers (444)',
      value: '444',
    },
    {
      label: 'Business, Professional, Labor, Political, and Similar Organizations (8139)',
      value: '7131',
    },
    {
      label: 'Chemical and Allied Products Merchant Wholesalers (4246)',
      value: '4246',
    },
    {
      label: 'Chemical Manufacturing (325)',
      value: '325',
    },
    {
      label: 'Civic and Social Organizations (8134)',
      value: '8134',
    },
    {
      label: 'Clothing Stores (4481)',
      value: '4481',
    },
    {
      label: 'Commercial and Industrial Machinery and Equipment Rental and Leasing (5324)',
      value: '7131',
    },
    {
      label: 'Community Care Facilities for the Elderly (6233)',
      value: '6233',
    },
    {
      label: 'Computer and Electronic Product Manufacturing (334)',
      value: '334',
    },
    {
      label: 'Computer Systems Design and Related Services',
      value: '5415',
    },
    {
      label: 'Construction of Building (236)',
      value: '236',
    },
    {
      label: 'Consumer Goods Rental (5322)',
      value: '5322',
    },
    {
      label: 'Couriers and Express Delivery Services (4921)',
      value: '4921',
    },
    {
      label: 'Crop Production (111)',
      value: '111',
    },
    {
      label: 'Data Processing, Hosting and Related Services (518)',
      value: '518',
    },
    {
      label: 'Depository Credit Intermediation (5221)',
      value: '5221',
    },
    {
      label: 'Direct Selling Establishments (4543)',
      value: '4543',
    },
    {
      label: 'Drugs and Druggists\' Sundries Merchant Wholesalers (4242)',
      value: '4242',
    },
    {
      label: 'Educational Services (611)',
      value: '611',
    },
    {
      label: 'Electrical and Electronic Goods Merchant Wholesalers (4236)',
      value: '7131',
    },
    {
      label: 'Electrical Equipment, Appliance, and Component Manufacturing (335)',
      value: '335',
    },
    {
      label: 'Electronic Shopping and Mail-Order Houses (4541)',
      value: '4541',
    },
    {
      label: 'Electronics and Appliance Stores (443)',
      value: '443',
    },
    {
      label: 'Executive, Legislative, and Other General Government Support (921)',
      value: '921',
    },
    {
      label: 'Fabricated Metal Product Manufacturing (332)',
      value: '332',
    },
    {
      label: 'Farm Product Raw Material Merchant Wholesalers (4245)',
      value: '4245',
    },
    {
      label: 'Fishing, Hunting and Trapping (114)',
      value: '114',
    },
    {
      label: 'Food and Beverage Stores (445)',
      value: '445',
    },
    {
      label: 'Food Manufacturing (311)',
      value: '311',
    },
    {
      label: 'Food Services and Drinking Places (722)',
      value: '722',
    },
    {
      label: 'Forestry and Logging',
      value: '113',
    },
    {
      label: 'Furniture and Home Furnishing Merchant Wholesalers (4232) ',
      value: '4243',
    },
    {
      label: 'Furniture and Home Furnishing Stores (442)',
      value: '442',
    },
    {
      label: 'Furniture and Related Product Manufacturing (337)',
      value: '337',
    },
    {
      label: 'Gambling Industries (7132)',
      value: '7132',
    },
    {
      label: 'Gasoline Stations (447)',
      value: '447',
    },
    {
      label: 'General Medical and Surgical Hospitals (6221)',
      value: '6221',
    },
    {
      label: 'General Merchandise Stores (452)',
      value: '452',
    },
    {
      label: 'General Rental Center (5323)',
      value: '5323',
    },
    {
      label: 'Grantmaking and Giving Services (8132)',
      value: '8132',
    },
    {
      label: 'Grocery and Related Product Merchant Wholesalers (4244)',
      value: '4244',
    },
    {
      label: 'Hardware, and Plumbing and heating Equipment and Supplies Merchant Wholesalers (4237)',
      value: '4237',
    },
    {
      label: 'Health and Personal Care Stores (446)',
      value: '446',
    },
    {
      label: 'Heavy and Civil Engineering Construction (237)',
      value: '237',
    },
    {
      label: 'Home Health Care Services (6216)',
      value: '6216',
    },
    {
      label: 'Insurance and Employee Benefit Funds (5251)',
      value: '5251',
    },
    {
      label: 'Insurance Carriers (5241)',
      value: '5241',
    },
    {
      label: 'Jewelry, Luggage, and Leather Goods Stores (4483)',
      value: '4483',
    },
    {
      label: 'Justice, Public Order, and Safety Activities (922)',
      value: '922',
    },
    {
      label: 'Leather and Allied Product Manufacturing (316)',
      value: '316',
    },
    {
      label: 'Legal Services (5411)',
      value: '5411',
    },
    {
      label: 'Lessors of NonFinancial Intangible Assets (except Copyrighted Works) (533)',
      value: '533',
    },
    {
      label: 'Lessors of Real Estate (5311)',
      value: '5311',
    },
    {
      label: 'Local Messengers and Local Delivery (4922)',
      value: '4922',
    },
    {
      label: 'Lumber and Other Construction Materials Merchant Wholesalers (4233)',
      value: '7132',
    },
    {
      label: 'Machinery Manufacturing (333)',
      value: '333',
    },
    {
      label: 'Machinery, Equipment, and Supplies Merchant Wholesalers (4238)',
      value: '4238',
    },
    {
      label: 'Management of Companies and Enterprises (551)',
      value: '551',
    },
    {
      label: 'Management, Scientific, and Technical Consulting Services (5416)',
      value: '5416',
    },
    {
      label: 'Medical and Diagnostic Laboratories (6215)',
      value: '6215',
    },
    {
      label: 'Metal and Mineral (except Petroleum) Merchant Wholesalers (4235)',
      value: '4235',
    },
    {
      label: 'Mining (except Oil and Gas) (212)',
      value: '212',
    },
    {
      label: 'Miscellaneous Durable Goods Merchant Wholesalers (4239)',
      value: '4239',
    },
    {
      label: 'Miscellaneous Manufacturing (339)',
      value: '339',
    },
    {
      label: 'Miscellaneous Nondurable Goods Merchant Wholesalers (4249)',
      value: '4249',
    },
    {
      label: 'Miscellaneous Store Retailers (453)',
      value: '453',
    },
    {
      label: 'Monetary Authorities-Central Bank (521)',
      value: '521',
    },
    {
      label: 'Mortgage and non-mortgage loan brokers (52231)',
      value: '52231',
    },
    {
      label: 'Motion Picture and sound Recording Industries (512)',
      value: '512',
    },
    {
      label: 'Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers (4231)',
      value: '4231',
    },
    {
      label: 'Museums, Historical Sites, and Similar Institutions (712)',
      value: '712',
    },
    {
      label: 'National Security and International Affairs (928)',
      value: '928',
    },
    {
      label: 'Non-depository Credit Intermediation (5222)',
      value: '5222',
    },
    {
      label: 'Nonmetallic Mineral Product Manufacturing (327)',
      value: '327',
    },
    {
      label: 'Nursing Care Facilities (6231)',
      value: '6231',
    },
    {
      label: 'Offices of Dentists (6212)',
      value: '6212',
    },
    {
      label: 'Offices of Other Health Practitioners (6213)',
      value: '6213',
    },
    {
      label: 'Offices of Physicians (6211)',
      value: '6211',
    },
    {
      label: 'Offices of Real Estate Agents and Brokers (5312)',
      value: '5312',
    },
    {
      label: 'Oil and Gas Extraction (211)',
      value: '211',
    },
    {
      label: 'Other Ambulatory Health Care Services (6219)',
      value: '6219',
    },
    {
      label: 'Other Amusement and Recreation Industries (7139)',
      value: '7139',
    },
    {
      label: 'Other Financial Investment Activities (5239)',
      value: '5239',
    },
    {
      label: 'Other Information Services (519)',
      value: '519',
    },
    {
      label: 'Other Investment Pools and Funds (5259)',
      value: '5259',
    },
    {
      label: 'Other Motor Vehicle Dealers (4412)',
      value: '4412',
    },
    {
      label: 'Other Pipeline Transportation (4869)',
      value: '4869',
    },
    {
      label: 'Other Professional, Scientific, and Technical Services (5419)',
      value: '5419',
    },
    {
      label: 'Other Residential Care Facilities (6239)',
      value: '6239',
    },
    {
      label: 'Other Telecommunications (5179)',
      value: '5179',
    },
    {
      label: 'Outpatient Care Centers (6214)',
      value: '6214',
    },
    {
      label: 'Paper and Paper Product Merchant Wholesalers (4241)',
      value: '4241',
    },
    {
      label: 'Paper Manufacturing (322)',
      value: '322',
    },
    {
      label: 'Performing Arts, Spectator Sports, and Related Industries (711)',
      value: '711',
    },
    {
      label: 'Personal and Laundry Services (812)',
      value: '812',
    },
    {
      label: 'Petroleum and Coal Products Manufacturing (324)',
      value: '324',
    },
    {
      label: 'Petroleum and Petroleum Products Merchant Wholesalers (4247)',
      value: '4247',
    },
    {
      label: 'Pipeline Transportation of Crude Oil (4861)',
      value: '4861',
    },
    {
      label: 'Pipeline Transportation of Natural Gas (4862)',
      value: '4862',
    },
    {
      label: 'Plastics and Rubber Products Manufacturing (326)',
      value: '326',
    },
    {
      label: 'Postal Service (491)',
      value: '491',
    },
    {
      label: 'Primary Metal Manufacturing (331)',
      value: '331',
    },
    {
      label: 'Printing and Related Support Activities (323)',
      value: '323',
    },
    {
      label: 'Private Households (814)',
      value: '814',
    },
    {
      label: 'Professional And Commercial Equipment and Supplies Merchant Wholesalers (4234)',
      value: '4234',
    },
    {
      label: 'Psychiatric and Substance Abuse Hospitals (6222)',
      value: '6222',
    },
    {
      label: 'Publishing Industries (except Internet) (511)',
      value: '511',
    },
    {
      label: 'Rail Transportation (482)',
      value: '482',
    },
    {
      label: 'Religious Organizations (8131)',
      value: '8131',
    },
    {
      label: 'Repair And Maintenance (811)',
      value: '811',
    },
    {
      label: 'Residential Mental Retardation, Mental health and Substance Abuse Facilities (6232)',
      value: '6232',
    },
    {
      label: 'Satellite Telecommunications (5174)',
      value: '5174',
    },
    {
      label: 'Scenic and Sightseeing Transportation (487)',
      value: '487',
    },
    {
      label: 'Scientific Research and Development Services (5417)',
      value: '5417',
    },
    {
      label: 'Securities and Commodity ContractsIntermediation and Brokerage (5231)',
      value: '5231',
    },
    {
      label: 'Securities and Commodity Exchanges (5232)',
      value: '5232',
    },
    {
      label: 'Shoe Stores (4482)',
      value: '4482',
    },
    {
      label: 'Social Advocacy Organizations (8133)',
      value: '8133',
    },
    {
      label: 'Social Assistance (624)',
      value: '624',
    },
    {
      label: 'Space Research and Technology (927)',
      value: '927',
    },
    {
      label: 'Specialized Design Services (5414)',
      value: '5414',
    },
    {
      label: 'Specialty (except Psychiatric and Substance Abuse) Hospitals (6223)',
      value: '6223',
    },
    {
      label: 'Specialty Trade Contractors (238)',
      value: '238',
    },
    {
      label: 'Sporting Goods, Hobby, Book, and Music Stores (451)',
      value: '451',
    },
    {
      label: 'Support Activities for Agriculture and Forestry (115)',
      value: '115',
    },
    {
      label: 'Support Activities for Mining (213)',
      value: '213',
    },
    {
      label: 'Support Activities for Transportation (488)',
      value: '448',
    },
    {
      label: 'Textile Mills (313)',
      value: '313',
    },
    {
      label: 'Textile Product Mills (314)',
      value: '314',
    },
    {
      label: 'Transit and Ground Passenger Transportation (485)',
      value: '485',
    },
    {
      label: 'Transportation Equipment Manufacturing (336)',
      value: '336',
    },
    {
      label: 'Truck Transportation (484)',
      value: '484',
    },
    {
      label: 'Utilities (221)',
      value: '221',
    },
    {
      label: 'Vending Machine Operators (4542)',
      value: '4542',
    },
    {
      label: 'Warehousing and Storage (493)',
      value: '493',
    },
    {
      label: 'Waste Management and Remediation Services (562)',
      value: '562',
    },
    {
      label: 'Water Transportation (483)',
      value: '483',
    },
    {
      label: 'Wholesale Electronic Markets and Agents and Brokers (425)',
      value: '425',
    },
    {
      label: 'Wired Telecommunications Carriers (5171)',
      value: '5171',
    },
    {
      label: 'Wireless Telecommunications Carriers (except Satellite) (5172)',
      value: '5172',
    },
    {
      label: 'Wood Product Manufacturing (321)',
      value: '321',
    },
  ].map(option => ({ ...option, name: option.label })),
};
